<template>
  <div class="tpage">
    <div class="topbar">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/tedu-record')">返回</el-button>
      <span class="title">编辑登记</span>
      <span class="topbar-pad"></span>
    </div>

    <div class="body">
      <el-card class="form-card" shadow="never" v-if="loaded">
        <el-form label-position="top" @submit.native.prevent>
          <div class="row2" v-if="!teacherRegister">
            <el-form-item label="星期">
              <el-select v-model="form.week_id" placeholder="选择星期" style="width:100%">
                <el-option v-for="w in weeks" :key="w.id" :label="w.week_name" :value="w.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="节次">
              <el-select v-model="form.section_id" placeholder="选择节次" style="width:100%">
                <el-option v-for="s in sections" :key="s.id"
                           :label="s.section_name + '（' + shortTime(s.start_time) + '-' + shortTime(s.end_time) + '）'"
                           :value="s.id"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="班级" v-if="!teacherRegister">
            <el-select v-model="form.school_class_id" filterable clearable
                       placeholder="输入班级名搜索，如11" style="width:100%">
              <el-option-group v-for="g in classGroups" :key="g.grade" :label="g.grade">
                <el-option v-for="c in g.items" :key="c.id" :label="className(c)" :value="c.id"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>

          <div class="row2">
            <el-form-item label="教师">
              <el-select v-model="form.teacher" filterable placeholder="选择教师" style="width:100%">
                <el-option v-for="t in teachers" :key="t.id" :label="t.name" :value="t.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程">
              <el-input v-model.trim="form.course" maxlength="10" placeholder="输入课程"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="分值">
            <el-input-number v-model="form.score" :min="-50" :max="50" :step="1" :precision="0"
                             controls-position="right" style="width:100%"></el-input-number>
          </el-form-item>

          <el-form-item label="情况说明">
            <el-input v-model.trim="form.market" type="textarea" :rows="3" maxlength="50" show-word-limit
                      placeholder="简要说明查到的情况"></el-input>
          </el-form-item>

          <el-form-item label="已有照片" v-if="pictures.length">
            <div class="pic-list">
              <el-image v-for="(p, pi) in pictures" :key="pi"
                        :src="imgUrl(p.image_url)" :preview-src-list="previewList"
                        class="pic-thumb" fit="cover"></el-image>
            </div>
            <p class="pic-tip">已有照片不可删除，可继续追加新照片</p>
          </el-form-item>

          <el-form-item label="追加照片（可不传）">
            <el-upload action="#" list-type="picture-card" :auto-upload="false" :limit="3"
                       :file-list="fileList" :on-change="onFileChange" :on-remove="onFileRemove"
                       :on-preview="onPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="block-btn" :loading="loading" @click="save">保存修改</el-button>
      </el-card>

      <p class="empty" v-if="loadFailed">记录加载失败，请返回列表重试</p>
    </div>

    <el-dialog :visible.sync="previewVisible" width="90%" custom-class="preview-dialog">
      <img :src="previewUrl" style="width:100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  eduWeeks, eduSections, eduClassList, eduTeacherList, eduUpdateRegister,
  eduUploadPicture, eduGetRegister, getTeacherLogin
} from '@/api/teacher.js'

const IMG_BASE = 'https://digital-school-education.oss-cn-shanghai.aliyuncs.com/public/static/education_register_image/'

export default {
  name: 'TeacherEduEdit',
  data() {
    return {
      weeks: [],
      sections: [],
      classes: [],
      teachers: [],
      teacherRegister: false, // true = 教师登记类型记录（无班级/星期/节次）
      editId: null,
      loaded: false,
      loadFailed: false,
      pictures: [],
      fileList: [],
      loading: false,
      previewVisible: false,
      previewUrl: '',
      form: {
        week_id: '',
        section_id: '',
        school_class_id: '',
        teacher: '',
        course: '',
        score: 0,
        market: ''
      }
    }
  },
  computed: {
    previewList() {
      return this.pictures.map((p) => IMG_BASE + p.image_url)
    },
    /** 班级按年级分组，下拉更好找 */
    classGroups() {
      const groups = []
      const index = {}
      this.classes.forEach((c) => {
        const grade = c.school_grade && c.school_grade.grade_name ? c.school_grade.grade_name : '其他'
        if (index[grade] === undefined) {
          index[grade] = groups.length
          groups.push({ grade: grade, items: [] })
        }
        groups[index[grade]].items.push(c)
      })
      return groups
    }
  },
  mounted() {
    if (!getTeacherLogin().token) {
      this.$router.replace('/tlogin')
      return
    }
    this.editId = Number(this.$route.query.id) || null
    if (!this.editId) {
      this.loadFailed = true
      return
    }
    this.loadBase()
  },
  methods: {
    loadBase() {
      Promise.all([eduWeeks(), eduSections(), eduClassList(), eduTeacherList(), this.loadRecord()])
        .then(([weeks, sections, classes, teachers, record]) => {
          this.weeks = weeks || []
          this.sections = sections || []
          this.classes = classes || []
          this.teachers = this.uniqueByName(teachers)
          if (record) {
            this.fill(record)
            this.loaded = true
          } else {
            this.loadFailed = true
          }
        })
        .catch(() => {
          this.loadFailed = true
          this.$message.error('数据加载失败，请返回重试')
        })
    },
    /** 教师表里可能同名不同学科，登记只存姓名，按姓名去重 */
    uniqueByName(list) {
      const seen = {}
      return (list || []).filter((t) => {
        if (!t || !t.name || seen[t.name]) return false
        seen[t.name] = true
        return true
      })
    },
    /** 优先用列表页暂存的记录（含已有照片），缓存不在则调详情接口 */
    loadRecord() {
      let cached = null
      try {
        cached = JSON.parse(sessionStorage.getItem('edu_edit_record') || 'null')
      } catch (e) {
        // 缓存损坏按无缓存处理，走接口兜底
      }
      if (cached && Number(cached.id) === this.editId) {
        sessionStorage.removeItem('edu_edit_record')
        return Promise.resolve(cached)
      }
      return eduGetRegister(this.editId).then((item) => (item && item.id ? item : null))
    },
    fill(item) {
      // 教师登记类型的记录没有班级/星期/节次，编辑时不强制填写
      this.teacherRegister = !(item.week_name || item.section_name || item.class_name)
      // 表里只存名称（week_name/section_name/class_name），没有 id，需按名称反查下拉选项
      const w = this.weeks.find((x) => x.week_name === item.week_name)
      const s = this.sections.find((x) => x.section_name === item.section_name)
      const c = this.classes.find((x) => this.className(x) === item.class_name)
      this.form.week_id = w ? w.id : ''
      this.form.section_id = s ? s.id : ''
      this.form.school_class_id = c ? c.id : ''
      this.form.teacher = item.teacher || ''
      // 老记录里的教师可能已离职/改名，不在名单中时补一个选项，避免下拉框显示空白
      if (this.form.teacher && !this.teachers.some((t) => t.name === this.form.teacher)) {
        this.teachers = [{ id: 'legacy-' + this.form.teacher, name: this.form.teacher }].concat(this.teachers)
      }
      this.form.course = item.course || ''
      this.form.score = Number(item.score) || 0
      this.form.market = item.market || ''
      this.pictures = Array.isArray(item.picture) ? item.picture : []
    },
    shortTime(t) {
      return t ? String(t).slice(0, 5) : ''
    },
    className(c) {
      const grade = c.school_grade && c.school_grade.grade_name ? c.school_grade.grade_name : ''
      return grade + (c.class_number != null ? c.class_number : '') + '班'
    },
    imgUrl(name) {
      return IMG_BASE + name
    },
    onFileChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList
    },
    onPreview(file) {
      this.previewUrl = file.url || (file.raw ? URL.createObjectURL(file.raw) : '')
      this.previewVisible = true
    },
    check() {
      // 教师登记类型记录没有班级/星期/节次，跳过这三项校验
      if (!this.teacherRegister) {
        if (!this.form.week_id) return '请选择星期'
        if (!this.form.section_id) return '请选择节次'
        if (!this.form.school_class_id) return '请选择班级'
      }
      if (!this.form.teacher) return '请选择教师'
      if (!this.form.course) return '请输入课程'
      if (!Number.isInteger(this.form.score)) return '分值必须是整数'
      if (!this.form.market) return '请填写情况说明'
      return ''
    },
    save() {
      const err = this.check()
      if (err) {
        this.$message.warning(err)
        return
      }
      const data = { id: this.editId }
      if (this.teacherRegister) {
        // 教师登记类型：不传班级/星期/节次，保留数据库原值（null）
        data.teacher = this.form.teacher
        data.course = this.form.course
        data.score = this.form.score
        data.market = this.form.market
      } else {
        const week = this.weeks.find((w) => w.id === this.form.week_id) || {}
        const section = this.sections.find((s) => s.id === this.form.section_id) || {}
        const cls = this.classes.find((c) => c.id === this.form.school_class_id) || {}
        data.week_id = this.form.week_id
        data.section_id = this.form.section_id
        data.school_class_id = this.form.school_class_id
        data.week_name = week.week_name || ''
        data.section_name = section.section_name || ''
        data.class_name = this.className(cls)
        data.teacher = this.form.teacher
        data.course = this.form.course
        data.score = this.form.score
        data.market = this.form.market
      }

      this.loading = true
      // 后端 get_register_edit 即 update，成功返回带 id 的记录
      eduUpdateRegister(data)
        .then((res) => {
          if (!res || !res.id) {
            this.loading = false
            this.$message.error('修改失败，请稍后重试')
            return
          }
          this.uploadPictures()
        })
        .catch(() => {
          this.loading = false
          this.$message.error('修改失败，请检查网络后重试')
        })
    },
    /** 依次上传追加的照片，失败不影响已保存的修改 */
    uploadPictures() {
      const files = this.fileList.map((f) => f.raw).filter(Boolean)
      if (files.length === 0) {
        this.done(true)
        return
      }
      let failed = 0
      const tasks = files.map((file) =>
        eduUploadPicture(file, this.editId).catch(() => {
          failed++
        })
      )
      Promise.all(tasks).then(() => {
        this.done(failed === 0)
      })
    },
    done(allOk) {
      this.loading = false
      if (allOk) {
        this.$message.success('修改成功')
      } else {
        this.$message.warning('修改已保存，部分照片上传失败')
      }
      this.$router.replace('/tedu-record')
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
}
.topbar {
  background: #fff;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef1f7;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
  .topbar-pad {
    width: 56px;
  }
}
.body {
  padding: 12px;
}
.form-card {
  border-radius: 10px;
  border: none;
  ::v-deep .el-card__body {
    padding: 16px 14px 18px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
  ::v-deep .el-form-item__label {
    padding-bottom: 2px;
    font-size: 13px;
    color: #5b6577;
    line-height: 22px;
  }
}
.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
/* 窄屏（手机竖屏）改为单列，避免下拉框标签被截断 */
@media screen and (max-width: 420px) {
  .row2 {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
.block-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  margin-top: 4px;
}
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 84px;
  height: 84px;
  line-height: 84px;
}
.pic-list {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  .pic-thumb {
    width: 64px;
    height: 64px;
    border-radius: 6px;
  }
}
.pic-tip {
  margin: 6px 0 0;
  font-size: 12px;
  color: #a8b0c0;
}
.empty {
  text-align: center;
  color: #a8b0c0;
  font-size: 13px;
  margin-top: 40px;
}
</style>
